import ApplicationController from 'javascript/controllers/application_controller';
import { parsePositiveIntOr } from 'javascript/utils/utils';

export default class extends ApplicationController {
  static targets = ['input', 'incrementButton', 'decrementButton'];

  connect() {
    this.showHideButtons();
  }

  incrementButtonClicked(e) {
    e.preventDefault();
    this.incrementQuantity();
    this.showHideButtons();
  }

  decrementButtonClicked(e) {
    e.preventDefault();
    this.decrementQuantity();
    this.showHideButtons();
  }

  incrementQuantity() {
    this.inputTarget.value = this.quantity + this.step;
  }

  decrementQuantity() {
    const next = this.quantity - this.step;
    this.inputTarget.value = next < 0 ? 0 : next;
  }

  showHideButtons() {
    const inputValue = parseInt(this.inputTarget.value);
    if (inputValue <= 0) {
      this.decrementButtonTarget.classList.add('hidden');
    } else {
      this.decrementButtonTarget.classList.remove('hidden');
    }
  }

  get quantity() {
    return parseInt(this.inputTarget.value);
  }

  get step() {
    return parsePositiveIntOr(this.data.get('step'), 1);
  }
}
